<template>
	<div class="container-fluid h-100">
		<div class="d-flex justify-content-center align-items-center h-100">
			<div class="col-12 col-md-8">
                <div class="text-center mb-3">
                    <groomy-logo class="logo_center_bis" />
                </div>
                <div class="box">
       
                        <h2>{{ $t('compte.validation_email') }}</h2>
                        
                        <!-- Envoi en cours -->
                        <div v-if="working && !isFromValidationUrl" class="text-center">
                            <LoadingSpinner />
                            <p class="mt-3">{{ $t('compte.envoi_email_confirmation') }}</p>
                        </div>

                        <!-- Confirmation envoyée -->
                        <div v-else-if="success && !isFromValidationUrl"  v-html="$t('compte.email_validation_envoye', [email])"></div>

                        <!-- Validation depuis URL en cours -->
                        <LoadingSpinner v-else-if="isFromValidationUrl && working"/>

                        <ErrorAlert v-if="error" :messageI18n="error" />
        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import User from '@/mixins/User'
import Navigation from '@/mixins/Navigation'

export default {
    name: 'EmailValidation',
    mixins: [User, Navigation],
    data: () => ({
        working: false,
        error: '',
        success: false,

        email: '',
        token: '',
        sign: '',
        user_id: '',
    }),
    created() {
        this.preinit_component()
    },
    mounted() {
        this.init_component()
    },
    methods: {
        preinit_component() {
            this.email = this.$route.params.email || this.getConfig('user_email') || ''
            this.token = this.$route.params.token
            this.sign  = this.$route.params.signature
			this.user_id = this.$route.params.userid
            this.temp_licence = this.$route.params.temp_licence

            // Si un code langue est passé dans l'URL, on switch la locale
            const lang = this.$route.params.lang
            if (lang && ['fr', 'en'].includes(lang)) {
                this.setLanguage(lang)
            }
        },
        init_component() {
            // Si le composant dispose de ces paramètres, c'est que l'on vient d'un lien de validation de l'email
            if(this.isFromValidationUrl) {
                return this.send_verif()
            }
            if(!this.isFromValidationUrl && !this.success) {
                this.ask_verif()
            }
        },
        async ask_verif() {
            this.working = true
            const result = await this.askValidationEmail(this.temp_licence)

            if(result) {
                this.success = true
            }
            this.working = false
        },     
        async send_verif() {
            this.working = true
            const result = await this.validateEmail(this.user_id, this.token, this.sign)

            if(result.type == 'failure') {
                this.working = false
                // Mauvaise signature d'url
                if(result.status == 403) {
                    this.error = 'global.mauvaise_signature'
                }
                // Trop de tentatives
                else if(result.status == 429) {
                    this.error = 'global.trop_de_tentatives'
                }

                return
            }
            else if(result.type == 'success') {
                this.success = true
                this.hasVerifiedEmail = true
                this.persistUserMailValid(true)
                // Recharge les permissions utilisateur pour mettre à jour les droits (VRFD)
                if (typeof this.initUserPermissions === 'function') {
                    await this.initUserPermissions();
                } else if (typeof this.$options.mixins !== 'undefined') {
                    // fallback si le mixin Permissions n'est pas direct
                    const permMixin = (this.$options.mixins.find(m => m.initUserPermissions) || {});
                    if (typeof permMixin.initUserPermissions === 'function') {
                        await permMixin.initUserPermissions.call(this);
                    }
                }
                this.goNext()
            }
        },
        async goNext() {
            // Si l'utilisateur n'est pas connecté, le rediriger vers la page de login
            if(!this.checkLocal()) {
                this.$router.push({
                    name: 'Home',
                    query: { email_validated: true }
                })
                return
            }
            
            // Toujours passer par Loading pour charger la config
            this.$router.push({
                name: 'Loading',
                query: {
                    redirect: '/home'
                }
            })
        }        
    },
    computed: {
        // Si le user a cliqué sur un lien de validation de son mail
        isFromValidationUrl() {
            return !!this.email && !!this.token && !!this.sign
        },
		isRenderedFromLogin() {
			return !this.isFromValidationUrl
		},
        hasVerifiedEmail: {
            get() {
                return this.$store.state.userAccess.hasEmailVerified
            },
            set(val) {
                this.$store.commit({ type: 'updateUserAccess', accessType: 'hasEmailVerified', val: val })
            }
        },
    },
    components: {
        ErrorAlert: () => import('@/components/Alert/ErrorAlert'),
        LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
    }
}
</script>